import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";

export default class LocationBar extends AlpineComponent {
  // @ts-ignore
  private intersectionObserver: IntersectionObserver;
  // @ts-ignore
  private crudObserver: MutationObserver;
  private unregister: () => void = () => {};

  constructor(public name: string) {
    super();
  }

  init() {
    this.name = this.$el.textContent ?? "";
    this.$watch("name", () => {
      this.$el.textContent = this.name;
    });
  }

  destroy() {
    this.unregister();
  }

  onContentScrollLocation(
    ev: CustomEvent<{ el: HTMLElement; location: string }>
  ) {
    if (ev.detail.el.id === "explorer-content") {
      this.name = ev.detail.location;
    }
  }
}
